<template>
  <div class="Game">
    <component
      :is="currentGame"
      v-if="currentGame"
      :key="reRenderGame"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Game',
  data() {
    return {
      currentGame: null,
    };
  },
  computed: {
    ...mapGetters({
      reRenderGame: 'gameConfig/getReRenderGame',
    }),
    userFromParentSite() {
      return document.referrer.indexOf(process.env.VUE_APP_PARENT_GAME_LIST) !== -1;
    },
  },
  mounted() {
    this.loadGame();
  },
  methods: {
    ...mapActions({
      fetchGameById: 'games/fetchGameById',
    }),
    async loadGame() {
      const game = await this.fetchGameById(this.$route.params.id);
      if (!game) {
        this.$router.push({ name: 'games' });
        return;
      }
      import(`../components/games/${game.gameFolderName}/${game.gameComponentName}`).then((m) => {
        this.currentGame = m.default;
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
